import { validateUrls } from "api/types"

export const urls = validateUrls({
  getProduct: productSlug => `/phoebus/v1/products/${productSlug}/`,
  getProductTax: () => `/pollux/v1/taxes/`,
})
